export default class AbstractForceGenerator {
    // Protected:
    attachToDispatchingFunction(masterFunc, slaveFunc) {
        masterFunc = this.turnToFunctionIfNot(masterFunc);
        slaveFunc = this.turnToFunctionIfNot(slaveFunc);
        let func = function(d) {
            let type = d.type;
            switch (type) {
                case "master":
                    return masterFunc(d);
                case "slave":
                    return slaveFunc(d);
                default:
                    Error("Invalid node type: " + type);
            }
        };
        return func;
    }

    // Private:
    turnToFunctionIfNot(input) {
        if (typeof input !== "function") {
            let func = () => input;
            return func;
        } else {
            return input;
        }
    }
}
